import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Select } from '@ngxs/store';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { CustomObject } from 'app/shared/modules/custom-objects/custom-objects.types';
import { BasicSetupArgs } from '../../../builder.types';
import { Observable } from 'rxjs';
import { FormBase } from '../builder-form.types';

@Component({
  selector: 'app-automation-builder-basic-setup-form',
  templateUrl: './basic-setup.component.html',
  styleUrls: ['./basic-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicSetupFormComponent extends FormBase<BasicSetupArgs> implements OnInit {
  @Select(ObjectsManagerState.get) objects$: Observable<CustomObject[]>;

  form = new FormGroup({
    name: new FormControl('', Validators.required),
    target_model: new FormControl(null, [Validators.required]),
  });

  get targetModelControlValue(): string {
    return this.targetModelControl.value;
  }

  private get targetModelControl(): FormControl {
    return this.form.get('target_model') as FormControl;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form.setValue({
      name: this.automation?.name ?? '',
      target_model: this.automation?.target_model ?? null,
    });
  }

  save(): void {
    this.ok.emit(this.form.getRawValue());
  }
}
